import React, { useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronRightMini,
  HomeMicroFill,
} from "../assets/SvgIcons";
import { Link, useNavigate } from "react-router-dom";
import ReviewSectionWithProduct from "../components/Shared/ReviewSectionWithProduct";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";
import axiosInstance from "../redux/helpers/axios";

const reviews = [
  {
    href: "https://www.trustpilot.com/reviews/dummy1",
    rating: 5,
    date: "November 1, 2024",
    review: "Great quality, exceeded expectations!",
    product: {
      name: "Dummy Watch 1",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 28, 2024",
    shippedFrom: "Country X",
    reviewer: {
      name: "John Doe",
      location: "Country X",
      initial: "JD",
      color: "blue",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy2",
    rating: 4,
    date: "November 2, 2024",
    review: "The product was good, but the delivery was delayed.",
    product: {
      name: "Dummy Watch 2",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 29, 2024",
    shippedFrom: "Country Y",
    reviewer: {
      name: "Jane Smith",
      location: "Country Y",
      initial: "JS",
      color: "red",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy3",
    rating: 3,
    date: "November 3, 2024",
    review: "The watch was fine, but customer support was not responsive.",
    product: {
      name: "Dummy Watch 3",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 30, 2024",
    shippedFrom: "Country Z",
    reviewer: {
      name: "Alex Johnson",
      location: "Country Z",
      initial: "AJ",
      color: "purple",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy4",
    rating: 5,
    date: "November 4, 2024",
    review: "Amazing watch, and the service was top-notch.",
    product: {
      name: "Dummy Watch 4",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 31, 2024",
    shippedFrom: "Country W",
    reviewer: {
      name: "Emily White",
      location: "Country W",
      initial: "EW",
      color: "orange",
    },
  },
];

const watchInfo = {
  name: "Demo Watch",
  details: "Two-Tone 116681 Rose Gold & Stainless Steel Yacht-Master II",
  listingCode: "LLX6H0",
  link: "/watch?id=watch_id",
  images: [
    "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
  ],
  badge: "Promoted",
  price: "$21,000",
  shipping: "$99",
  location: "United States of America, Florida, Sunny Isles Beach",
  condition: "Used (Very good) | Original box | No original papers",
  additional_info:
    "Rolex Steel 36mm Automatic 126000 new United States of America, New York, New York",
  description:
    "Up for grabs is a Rolex Yachtmaster II, made in 18kt rose gold and stainless steel, reference 116681. This particular example comes with its original Rolex box. The Rolex Yachtmaster II itself is in very good pre-owned condition, showing virtually no wear, having been recently detailed. Further, the watch has 11 full links.",
  sku: [
    {
      name: "Basic Info",
      subsku: [
        { name: "Listing Code", value: "LLX6H0" },
        { name: "Brand", value: "Rolex" },
        { name: "Model", value: "Yacht-Master II" },
        { name: "Reference Number", value: "116681 (Two-tone)" },
        { name: "Movement", value: "Automatic" },
        { name: "Case Material", value: "Gold/Steel" },
        { name: "Bracelet Material", value: "Gold/Steel" },
        { name: "Year of Production", value: "Unknown" },
        {
          name: "Condition",
          value:
            "The item shows minor signs of wear, such as small, intangible scratches.",
        },
        { name: "Scope of Delivery (Box)", value: "Original box" },
        { name: "Scope of Delivery (Papers)", value: "No original papers" },
        { name: "Gender", value: "Men's watch/Unisex" },
        {
          name: "Location (Country)",
          value: "Sunny Isles Beach,Florida, United States of America",
        },
        { name: "Price", value: "$21,000" },
        { name: "Availability", value: "Item is in stock" },
      ],
    },
    {
      name: "Caliber",
      subsku: [
        { name: "Movement", value: "Automatic" },
        { name: "Caliber Number", value: "4161" },
        { name: "Power Reserve", value: "72 h" },
        { name: "Number of Jewels", value: "42" },
      ],
    },
    {
      name: "Case",
      subsku: [
        { name: "Material", value: "Gold/Steel" },
        { name: "Diameter", value: "44 mm" },
        { name: "Water Resistance", value: "10 ATM" },
        { name: "Crystal", value: "Sapphire crystal" },
        { name: "Dial Color", value: "White" },
        { name: "Dial Numerals", value: "No numerals" },
      ],
    },
    {
      name: "Bracelet",
      subsku: [
        { name: "Material", value: "Gold/Steel" },
        { name: "Color", value: "Gold/Steel" },
        { name: "Clasp Type", value: "Fold clasp" },
        { name: "Clasp Material", value: "Gold/Steel" },
      ],
    },
  ],
};

const faqs = [
  {
    id: 350,
    question: "How does WristLink verify dealers?",
    answer:
      "Every dealer undergoes a thorough verification process to ensure the safety and integrity of our marketplace.",
  },
  {
    id: 351,
    question: "What makes WristLink different from other platforms?",
    answer:
      "WristLink is built exclusively for luxury watch dealers, offering a subscription-only, commission-free model with a verified network.",
  },
  {
    id: 352,
    question: "Are there any hidden fees?",
    answer:
      "No, WristLink operates on a simple subscription basis. No commissions, no hidden costs.",
  },
  {
    id: 353,
    question: "How do I connect with other dealers?",
    answer:
      "Once verified, you can directly connect with dealers within the platform, browse inventory, and trade securely.",
  },
];

const serviceInfoArray = [
  {
    name: "Commitment to Authenticity",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-authenticity-guarantee.svg",
    description:
      "We require all dealers to exclusively list authentic watches. However, if you have any doubts after receiving your watch, you can contact our support team for assistance. We'll review your case and work together with the dealer to find a solution.",
  },
  {
    name: "Strict dealer guidelines",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-dealer-guidelines.svg",
    description:
      "In the interest of security, dealers on our marketplace must follow a strict set of rules. Before a professional dealer can sell on our platform, they must provide us with their photo ID, commercial register entry, business address, and tax number. Furthermore, we require all dealers to follow our strict dealer guidelines.",
  },
  {
    name: "Insured shipping",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-safe-delivery.svg",
    description:
      "Dealers ship every order fully insured, so you can make both domestic and international purchases risk-free.",
  },
  {
    name: "WristLink's quality & security team",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-team.svg",
    description:
      "Our 40-person quality & security team works hard to detect suspicious listings and address issues before they arise, allowing you to focus on what's most important – finding the right watch!",
  },
  {
    name: "Escrow Service unavailable",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-no-buyers-protection.svg",
    description:
      "Unfortunately, we cannot offer WristLink's Escrow Service for this listing. Instead, you will pay the purchase price directly to the seller. As always, our multilingual support team would be happy to offer assistance should you need it.",
  },
  {
    name: "Return policy determined by the dealer",
    image:
      "https://static.chrono24.com/images/default/illustrations/sv-no-return.svg",
    description:
      "Please note that this dealer has their own return policy. You can view it by clicking the provided link.",
  },
];

const WatchDescription = () => {
  const dealer = JSON.parse(localStorage.getItem("dealer"));

  const navigate = useNavigate();

  const handleContactDealer = () => {
    const data = {
      userOne: dealer?._id,
      userTwo: "67489d17d205cae7fb9cde77",
      msgs: [],
    };

    axiosInstance
      .post(`/messenger/chats/start-conversation`, data)
      .then((res) => {
        navigate("/user/messenger");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <BasicInformation
        watchInfo={watchInfo}
        handleContactDealer={handleContactDealer}
      />
      <SKUInformation
        watchInfo={watchInfo}
        serviceInfoArray={serviceInfoArray}
      />

      {/* <ReviewSectionWithProduct
        reviews={reviews}
        sectionClassName={"bg-secondary text-white"}
        navBtnStyle={{ color: "white" }}
        ctaBtnStyle={{ borderColor: "white" }}
        sectionTitle={"Over 800,000 satisfied watch buyers worldwide"}
        sectionSubTitle={
          "Wrist-Wurx dealers receive great ratings: 4.8 out of 5 "
        }
      /> */}
      <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
        <FaqAndContactSection
          faqs={faqs}
          title={"Frequently Asked Questions"}
        />
      </section>
    </>
  );
};

export default WatchDescription;

//BasicInformation

const BasicInformation = ({ watchInfo, handleContactDealer }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex lg:flex-row md:flex-col sm:flex-col gap-6">
      <div className="lg:w-1/2 md:w-full sm:w-full">
        <ImageGallery images={watchInfo?.images} />
      </div>
      <div className="lg:w-1/2 md:w-full sm:w-full">
        <MiniNavbar />
        <MinimalInfo
          watchInfo={watchInfo}
          handleContactDealer={handleContactDealer}
        />
      </div>
    </section>
  );
};

const ImageGallery = ({ images }) => {
  const scrollRef = useRef(null);
  const imgSmallScrollViewRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleScroll = () => {
    const scrollPosition = scrollRef.current.scrollLeft;
    const itemWidth = scrollRef.current.clientWidth; // width of the container
    const newIndex = Math.ceil(scrollPosition / itemWidth); // calculate the new index based on scroll position
    setCurrentIndex(newIndex);
  };
  return (
    <div className="w-full">
      {/* IMAGE SCROLL GALLARY BIG */}
      <div className="relative w-full">
        <div
          ref={scrollRef}
          className="w-full flex overflow-x-scroll no-scrollbar rounded-lg"
          onScroll={handleScroll}
        >
          {images?.map((img, index) => {
            return (
              <img
                key={index}
                src={img}
                alt=""
                className="  aspect-square object-cover shadow-sm"
              />
            );
          })}
        </div>

        {/* IMG TOGGLE  BTNS */}
        <div className="w-full  flex justify-between items-center px-2  absolute top-1/2 ">
          {/* Previous Button */}

          <button
            onClick={() => {
              scrollRef.current.scrollBy({
                left:
                  -1 * (scrollRef.current ? scrollRef.current.clientWidth : 0),
                behavior: "smooth",
              });
            }}
            className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
            aria-label="Previous page"
          >
            {ChevronLeft}
          </button>

          {/* Next Button */}
          <button
            onClick={() => {
              scrollRef.current.scrollBy({
                left:
                  1 * (scrollRef.current ? scrollRef.current.clientWidth : 0),
                behavior: "smooth",
              });
            }}
            className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
            aria-label="Next page"
          >
            {ChevronRight}
          </button>
        </div>
      </div>

      {/* ALL IMAGE SMALL BOTTOM VIEW SCROLL VIEW */}

      <div className="relative w-full mt-2">
        <div
          ref={imgSmallScrollViewRef}
          className="w-full flex gap-2 overflow-x-scroll no-scrollbar"
        >
          {images?.map((img, index) => {
            return (
              <img
                onClick={() => {
                  scrollRef.current.scrollBy({
                    left:
                      1 *
                      (scrollRef.current
                        ? scrollRef.current.clientWidth * (index - currentIndex)
                        : 0),
                    behavior: "smooth",
                  });
                }}
                key={index}
                src={img}
                alt=""
                className="w-[120px] rounded-lg  aspect-square object-cover shadow-sm"
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

const MiniNavbar = () => {
  return (
    <nav className="">
      <div className="flex gap-2 text-[12px] mt-2">
        {/* Home Icon Link */}
        <Link to="/">{HomeMicroFill}</Link>

        {/* External Link Icon and Text */}
        {ChevronRightMini}
        <span className="text-ellipsis" title="Rolex watches">
          Rolex watches
        </span>

        {/* External Link Icon and Text */}
        {ChevronRightMini}
        <span className="text-ellipsis" title="Rolex watches">
          Rolex watches
        </span>
      </div>
    </nav>
  );
};

const MinimalInfo = ({ watchInfo, handleContactDealer }) => {
  const navigate = useNavigate();
  return (
    <div className="my-4">
      <p className="flex text-[12px] mb-2 bg-[#D2D1CA] w-[80px] justify-center items-center rounded ">
        Pre Owned
      </p>
      <h2 className="lg:text-2xl md:text-xl sm:text-lg">{watchInfo?.name}</h2>
      <p className=" mb-4">{watchInfo?.details}</p>

      <p className=" text-[14px]">{watchInfo?.condition}</p>
      <p className="lg:text-2xl md:text-xl sm:text-lg font-medium mt-4">
        {watchInfo?.price}
      </p>
      {/* <p className="text-[12px] ">
        + {watchInfo?.shipping} for insured shipping to Bangladesh
      </p> */}

      <button
        className="w-full py-3 rounded-lg  bg-oldblue font-bold text-white mt-4"
        onClick={() => handleContactDealer()}
      >
        {" "}
        Contact Dealer
      </button>
      <button
        onClick={() => handleContactDealer()}
        className="w-full py-3 rounded-lg  bg-primary  mt-2 mb-4"
      >
        {" "}
        Make An Offer
      </button>

      {/* SECURITY SECTION */}
      {/* <div className="bg-gray-100 p-4 rounded-lg">
        <div className="flex mb-2">
          <span className="text-lg">Security on WristLink</span>
        </div>
        <div className="text-[12px]">
          <ul className="list-none">
            <li className="flex items-center">
              &#x2715; Escrow Service unavailable
            </li>
            <li className="flex items-center">
              &#x2713; Commitment to Authenticity
            </li>
            <li className="flex items-center">
              &#x2715; Return policy determined by the dealer
            </li>
          </ul>

          <button
            type="button"
            className="text-[12px] underline text-blue-500 hover:text-blue-700 mt-2"
          >
            Learn more about security on WristLink
          </button>
        </div>
      </div> */}

      {/* SHIPPING AND SELLER INFO */}

      <div className="mt-6">
        <h2 className="text-[15px] font-medium my-3">Dealer Information</h2>

        {/* <div className="mb-2 text-[14px]">
          <p className="flex items-center ">Item is in stock</p>
          <div className="flex gap-2 items-center">
            <p className="">Anticipated delivery: 11/14 - 11/30</p>{" "}
          </div>
        </div> */}
        <div className="flex justify-between">
          <div
            className="flex gap-4"
            onClick={() => navigate("/supplier/details/1")}
          >
            <img
              src="https://wristlink.s3.me-south-1.amazonaws.com/1478195818-aleeha-logo.png"
              className="h-[50px] w-[50px] border rounded-full"
            />
            <div>
              <button className="text-[16px] font-semibold underline mb-1">
                Aleeha Watch BD
              </button>
              <p>Bangladesh</p>
            </div>
          </div>

          <div className="mb-2 flex justify-between items-center text-[14px]">
            <p className="flex items-center" title="4.9 out of 5 stars">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="black"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="black"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="black"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="black"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                />
              </svg>
              4.3 ( 78 )
            </p>
          </div>
        </div>

        {/* DEALER BADGE */}

        {/* <div className="mb-4 mt-3 flex space-x-2">
          <button className="relative cursor-pointer p-1  rounded-full">
            <img
              src="https://cdn-icons-png.flaticon.com/128/3172/3172183.png"
              width={56}
              height={56}
              alt=""
              className="rounded-full p-2.5 border"
            />
          </button>

          <button className="relative cursor-pointer p-1  rounded-full">
            <img
              src="https://cdn-icons-png.flaticon.com/128/2769/2769339.png"
              width={56}
              height={56}
              alt=""
              className="rounded-full p-2.5 border"
            />
          </button>
          <button className="relative cursor-pointer p-1  rounded-full">
            <img
              src="https://cdn-icons-png.flaticon.com/128/2912/2912536.png"
              width={56}
              height={56}
              alt=""
              className="rounded-full p-2.5 border"
            />
          </button>
        </div> */}

        {/* <button
          className="border font-semibold text-[15px] text-center py-3 rounded-lg w-full bg-oldblue text-white mt-4"
        >
          Contact dealer
        </button> */}
      </div>
    </div>
  );
};

//SKU
const SkuTableGenerator = ({ mainsku }) => {
  return (
    <div className="lg:w-2/4 md:w-2/4 sm:w-full">
      <h2 className="lg:text-xl md:text-lg sm:text-lg font-medium text-center py-2 mt-6">
        {mainsku?.name}
      </h2>
      <div>
        {mainsku?.subsku?.map((sku, index2) => {
          return (
            <div
              key={index2}
              className={`flex gap-0 text-[14px] ${
                index2 === 0 && "border-t  border-t-oldblue border-dashed"
              }`}
            >
              <p
                className={`w-2/6 font-medium py-2 px-1 border-x border-b  border-x-oldblue border-b-oldblue  border-dashed`}
              >
                {sku?.name}
              </p>
              <p className="w-4/6 py-2 px-1 border-r border-b  border-r-oldblue border-b-oldblue border-dashed">
                {sku?.value}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const DetailsSkuSection = ({ watchInfo }) => {
  return (
    <div className="flex lg:flex-col md:flex-col sm:flex-col gap-6 ">
      <div className="lg:w-full md:w-full sm:w-full">
        <h2 className="lg:text-xl md:text-lg sm:text-lg border-b border-b-oldblue border-dashed py-2 mt-6">
          Description
        </h2>
        <p className="text-[18px] py-2">{watchInfo?.description}</p>
      </div>
      <div className="lg:w-full md:w-full sm:w-full flex flex-col items-center">
        {watchInfo?.sku?.map((mainsku, index) => {
          return <SkuTableGenerator mainsku={mainsku} key={index} />;
        })}
      </div>
    </div>
  );
};
const SecuritySection = ({ serviceInfoArray }) => {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6 mt-6">
      {serviceInfoArray?.map((info, index) => {
        return (
          <div key={index} className="border rounded-lg lg:p-8 md:p-4 sm:p-4">
            <img src={info?.image} className="aspect-square mx-auto" alt="" />
            <h2 className="lg:text-xl md:text-lg sm:text-lg text-center  mx-auto my-3">
              {info?.name}
            </h2>
            <p className="lg:text-[14px] md:text-[12px] sm:text-[12px] text-center mx-auto">
              {info?.description}
            </p>
          </div>
        );
      })}
    </div>
  );
};

const SKUInformation = ({ watchInfo, serviceInfoArray }) => {
  const [activeSection, setSection] = useState(1);
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 ">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl">
        More About This Listing
      </h2>

      <div className="border-b border-b-oldblue border-dashed mt-8 ">
        <button
          className={`px-3 py-2 border-b-2 border-b-oldblue mb-[-1.5px] ${
            activeSection === 1
              ? " border-b-oldblue  font-medium"
              : " border-b-white "
          }`}
          onClick={() => setSection(1)}
        >
          Details
        </button>
        {/* <button
          className={` py-2 border-b-2 border-b-oldblue ${
            activeSection === 2
              ? " border-b-oldblue  font-medium"
              : " border-b-white "
          }`}
          onClick={() => setSection(2)}
        >
          Security
        </button> */}
      </div>
      {activeSection === 1 ? (
        <DetailsSkuSection watchInfo={watchInfo} />
      ) : (
        <SecuritySection serviceInfoArray={serviceInfoArray} />
      )}
    </section>
  );
};

//recomandation
